<ng-container *ngIf="show">
  <app-callout type="info" title="{{ scopeConfig.title | i18n }}">
    {{ scopeConfig.description | i18n: scopeConfig.scopeIdentifier }}
  </app-callout>
</ng-container>
